import convertArrayToCSV from 'convert-array-to-csv';
import moment from 'moment';
import XMLJs from 'xml-js';
import * as ExcelJS from 'exceljs';

import { DATE_FORMAT } from '../../../common/constants';

export const convertDataToReport = async (fileType: string, data: Array<any>, worksheetName: string) => {
  let result = null;

  if (!data || data.length <= 0) {
    return result;
  }

  if (fileType === 'csv') {
    const csv = convertArrayToCSV(data);
    result = csv.toString();
  } else if (fileType === 'xml') {
    let consumptionCollection: Consumption.IConsumptionCollection = {
      consumption: {
        elecMonthlyConsumption: data,
      },
    };

    result = XMLJs.js2xml(consumptionCollection, { compact: true, spaces: 2 });
  } else if (fileType === 'xlsx') {
    result = await createXlsxFile(data, worksheetName);
  }
  return result;
};

export const formatHHData = (
  data: Array<Api.IDraxHHPeriod>,
  customerId: string,
  entityId: string,
  entityType: string,
  startDate: string
) => {
  const mpanCore = entityId;

  let row: any = {
    MPAN: mpanCore,
    Date: moment(startDate).format(DATE_FORMAT),
  };

  let formattedData: any = [];
  let sum = 0;
  for (let i = 0; i < 50; i++) {
    row[`HH${i + 1}`] = data[i]?.consumptionValue;
    sum += data[i]?.consumptionValue ? data[i]?.consumptionValue : 0;
  }
  row['Total'] = sum.toFixed(1);

  // Actual / Estimated
  for (let i = 0; i < 50; i++) {
    row[`HH${i + 1}_Type`] = data[i] ? (data[i].isEstimated ? 'E' : 'A') : '';
  }

  formattedData.push(row);

  return formattedData;
};

export const createXlsxFile = async (totalArrayToConvert: any[], worksheetName: string) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(worksheetName);

  const headers = Object.keys(totalArrayToConvert[0]);
  worksheet.columns = headers.map(key => ({
    header: key,
    key,
    width: 20,
  }));

  totalArrayToConvert.forEach(item => {
    const row = worksheet.addRow({
      ...item,
      mpan: String(item.mpan),
    });

    // Sets to text to stop warning
    if (item.mpan) {
      row.getCell('mpan').numFmt = '@';
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  return buffer;
};

export const csvToObjects = (csv: string): Record<string, string>[] => {
  const lines = csv.split('\n');
  const headers = lines[0].split(',').map(h => h.replace(/^"|"$/g, '').trim());

  return lines.slice(1).map(line => {
    const values = line.split(',').map(v => v.replace(/^"|"$/g, '').trim());
    return headers.reduce((obj, header, i) => {
      obj[header.trim()] = values[i]?.trim() ?? '';
      return obj;
    }, {} as Record<string, string>);
  });
};
